<template>
  <div class="assign-project-form bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
    <div class="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
      <div class="ml-4 mt-4">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Assign to a Project
        </h3>
        <p class="mt-1 text-sm leading-5 text-gray-500">
          All of the {{ modelPrettified }}s that have been selected will be assigned to the project of your choice.
        </p>
      </div>
    </div>
    <div class="modal-body">
      <multiselect v-if="projectsLoaded"
        v-model="selectedProject"
        :options="projects"
        label="name"
        track-by="id"
        placeholder="Select project"
        :show-labels="false"
        :multiple="false"
      />
      <div class="action-buttons">
        <button type="button" class="btn btn-danger" @click="cancel">Cancel</button>
        <button type="button" class="btn btn-primary" @click="submit" :disabled="!selectedProject">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { startCase } from 'lodash-es'
  import Multiselect from 'vue-multiselect'
  import BulkActionService from '@services/BulkActionService'
  import FlashMessages from '@services/FlashMessages'

  export default {
    name: 'assign-project-form',
    components: {
      Multiselect,
    },
    data () {
      return {
        projects: [],
        projectsLoaded: false,
        selectedProject: null,
        processing: false,
      }
    },
    computed: {
      modelPrettified () {
        return startCase(this.model)
      },
    },
    methods: {
      requestProjects () {
        axios.get('/projects.json')
          .then(projects => {
            this.projects = [{ id: null, name: 'No Project' }, ...projects.data]
            this.projectsLoaded = true
          })
      },
      cancel () {
        this.$emit('cancel')
      },
      close () {
        this.$emit('close')
      },
      submit () {
        if (!this.processing) {
          this.processing = true
          BulkActionService.assignProject(this.ids, this.model, this.selectedProject.id)
            .then(resp => {
              FlashMessages.success(`${resp.data.result} record(s) assigned to the ${this.selectedProject.name} project.`, 'Success')
              this.close()
            })
            .catch(resp => {
              FlashMessages.error(`Failed to assign to project. Please try again later.`, 'Error')
              this.close()
            })
        }
      },
    },
    created () {
      this.requestProjects()
    },
    props: {
      ids: {
        type: Array,
        required: true,
      },
      model: {
        type: String,
        required: true,
      },
    },
  }
</script>

<style lang="scss">
  .assign-project-form {
    .modal-body {
      margin-top: 15px;

      .action-buttons {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
</style>
